module.exports = __webpack_public_path__ + "img/events_4.136e0a9a.jpg";